import { apiClient, signApiRequest } from ".";
import { useMutation } from "@tanstack/react-query";
import { CustomerCredentials } from "../ui/customerDataStore";
import { captureException } from "@sentry/react";
interface Payload {
  phoneNumber: string;
  email: string;
  personalNumber: string;
  transactionId: string;
  validFrom: string;
  validTo: string | null;
  name: string;
  credentials: CustomerCredentials;
  signText: string;
  nonce?: string;
  returnPath?: string;
}

export const signPOA = async ({
  phoneNumber,
  email,
  personalNumber,
  transactionId,
  validFrom,
  validTo,
  name,
  credentials,
  signText,
  nonce,
  returnPath,
}: Payload) => {
  const signedRequest = await signApiRequest(
    "POST",
    `${import.meta.env.VITE_API_URL}/auth/sign`,
    credentials,
    { "content-type": "application/json" },
    {
      phoneNumber,
      email,
      personalNumber,
      transactionId,
      validFrom,
      validTo,
      name,
      signText,
      nonce,
      returnPath,
    },
  );

  const response = await apiClient(signedRequest);

  return response.data;
};

export const useSignPOA = () =>
  useMutation({
    onError: (error) => {
      captureException(error, {
        tags: {
          operation: "postSignPOA",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/auth/sign",
        },
        level: "error",
      });
    },
    mutationFn: ({
      phoneNumber,
      email,
      personalNumber,
      transactionId,
      validFrom,
      validTo,
      name,
      credentials,
      signText,
      nonce,
      returnPath,
    }: Payload) =>
      signPOA({
        phoneNumber,
        email,
        personalNumber,
        transactionId,
        validFrom,
        validTo,
        name,
        credentials,
        signText,
        nonce,
        returnPath,
      }),
  });
